/* eslint-disable */
/*
 * jQuery Tabs plugin
 */

(function ($, $win) {
  'use strict';

  function Tabset($holder, options) {
    this.$holder = $holder;
    this.options = options;

    this.init();
  }

  Tabset.prototype = {
    init: function () {
      this.$tabLinks = this.$holder.find(this.options.tabLinks);

      this.setStartActiveIndex();
      this.setActiveTab();

      if (this.options.autoHeight) {
        this.$tabHolder = $(this.$tabLinks.eq(0).attr(this.options.attrib)).parent();
      }

      this.makeCallback('onInit', this);
    },

    setStartActiveIndex: function () {
      var $classTargets = this.getClassTarget(this.$tabLinks);
      var $activeLink = $classTargets.filter('.' + this.options.activeClass);
      var $hashLink = this.$tabLinks.filter('[' + this.options.attrib + '="' + location.hash + '"]');
      var activeIndex;

      if (this.options.checkHash && $hashLink.length) {
        $activeLink = $hashLink;
      }

      activeIndex = $classTargets.index($activeLink);

      this.activeTabIndex = this.prevTabIndex = activeIndex === -1 ? (this.options.defaultTab ? 0 : null) : activeIndex;
    },

    setActiveTab: function () {
      var self = this;

      this.$tabLinks.each(function (i, link) {
        var $link = $(link);
        var $classTarget = self.getClassTarget($link);
        var $tab = $($link.attr(self.options.attrib));

        if (i !== self.activeTabIndex) {
          $classTarget.removeClass(self.options.activeClass);
          $tab.addClass(self.options.tabHiddenClass).removeClass(self.options.activeClass);
        } else {
          $classTarget.addClass(self.options.activeClass);
          $tab.removeClass(self.options.tabHiddenClass).addClass(self.options.activeClass);
        }

        self.attachTabLink($link, i);
      });
    },

    attachTabLink: function ($link, i) {
      var self = this;

      $link.on(this.options.event + '.tabset', function (e) {
        e.preventDefault();

        if (self.activeTabIndex === self.prevTabIndex && self.activeTabIndex !== i) {
          self.activeTabIndex = i;
          self.switchTabs();
        }
        if (self.options.checkHash) {
          location.hash = jQuery(this).attr('href').split('#')[1];
        }
      });
    },

    resizeHolder: function (height) {
      var self = this;

      if (height) {
        this.$tabHolder.height(height);
        setTimeout(function () {
          self.$tabHolder.addClass('transition');
        }, 10);
      } else {
        self.$tabHolder.removeClass('transition').height('');
      }
    },

    switchTabs: function () {
      var self = this;

      var $prevLink = this.$tabLinks.eq(this.prevTabIndex);
      var $nextLink = this.$tabLinks.eq(this.activeTabIndex);

      var $prevTab = this.getTab($prevLink);
      var $nextTab = this.getTab($nextLink);

      $prevTab.removeClass(this.options.activeClass);

      if (self.haveTabHolder()) {
        this.resizeHolder($prevTab.outerHeight());
      }

      setTimeout(
        function () {
          self.getClassTarget($prevLink).removeClass(self.options.activeClass);

          $prevTab.addClass(self.options.tabHiddenClass);
          $nextTab.removeClass(self.options.tabHiddenClass).addClass(self.options.activeClass);

          self.getClassTarget($nextLink).addClass(self.options.activeClass);

          if (self.haveTabHolder()) {
            self.resizeHolder($nextTab.outerHeight());

            setTimeout(function () {
              self.resizeHolder();
              self.prevTabIndex = self.activeTabIndex;
              self.makeCallback('onChange', self);
            }, self.options.animSpeed);
          } else {
            self.prevTabIndex = self.activeTabIndex;
          }
        },
        this.options.autoHeight ? this.options.animSpeed : 1,
      );
    },

    getClassTarget: function ($link) {
      return this.options.addToParent ? $link.parent() : $link;
    },

    getActiveTab: function () {
      return this.getTab(this.$tabLinks.eq(this.activeTabIndex));
    },

    getTab: function ($link) {
      return $($link.attr(this.options.attrib));
    },

    haveTabHolder: function () {
      return this.$tabHolder && this.$tabHolder.length;
    },

    destroy: function () {
      var self = this;

      this.$tabLinks.off('.tabset').each(function () {
        var $link = $(this);

        self.getClassTarget($link).removeClass(self.options.activeClass);
        $($link.attr(self.options.attrib)).removeClass(self.options.activeClass + ' ' + self.options.tabHiddenClass);
      });

      this.$holder.removeData('Tabset');
    },

    makeCallback: function (name) {
      if (typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call(arguments);
        args.shift();
        this.options[name].apply(this, args);
      }
    },
  };

  $.fn.tabset = function (opt) {
    var args = Array.prototype.slice.call(arguments);
    var method = args[0];

    var options = $.extend(
      {
        activeClass: 'active',
        addToParent: false,
        autoHeight: false,
        checkHash: false,
        defaultTab: true,
        animSpeed: 500,
        tabLinks: 'a',
        attrib: 'href',
        event: 'click',
        tabHiddenClass: 'js-tab-hidden',
      },
      opt,
    );
    options.autoHeight = options.autoHeight;

    return this.each(function () {
      var $holder = jQuery(this);
      var instance = $holder.data('Tabset');

      if (typeof opt === 'object' || typeof opt === 'undefined') {
        $holder.data('Tabset', new Tabset($holder, options));
      } else if (typeof method === 'string' && instance) {
        if (typeof instance[method] === 'function') {
          args.shift();
          instance[method].apply(instance, args);
        }
      }
    });
  };
})(jQuery, jQuery(window));
(function ($) {
  function MobileNav() {
    var navopener = $('.navmain-opener'),
      navwrap = $('.navmain'),
      links = navwrap.find('a'),
      navactive = 'navmain-active';

    navopener.click(function (e) {
      e.preventDefault();
      $('body').toggleClass(navactive);
    });

    $('.navmain li').each(function () {
      var item = $(this);
      var drop = item.find('ul');
      var link = item.find('a').eq(0);
      if (drop.length) {
        item.addClass('hasdrop');
        if (link.length) link.addClass('hasdrop-a').attr({'data-more': '', 'data-outside': ''});
      }
    });

    links.click(function () {
      $(this).hasClass('hasdrop-a') ? false : $('body').removeClass(navactive);
    });

    $('html').on('click touchstart pointerdown MSPointerDown', function (e) {
      var target = $(e.target);
      if (!target.closest(navopener).length && !target.closest(navwrap).length) {
        $('body').removeClass(navactive);
      }
    });
  }

  function FixedHeader() {
    if ($('body').hasClass('nav-hidden')) return false;
    if ($('body').hasClass('nav-fixed')) {
      jQuery('.header-v3').addClass('header-sticky').addClass('header-visible');
      return false;
    }
    var lastScroll = jQuery(window).scrollTop();
    jQuery(window).on('scroll', function (e) {
      if (jQuery('body').hasClass('navmain-active') && window.innerWidth < 1024) return;
      var win = jQuery(window),
        currentScroll = win.scrollTop(),
        header = jQuery('.header-v3'),
        promo = jQuery('.promo-banner-wrap');

      var pheight = promo.length ? promo.outerHeight() : 0;

      if (currentScroll > lastScroll) {
        if (currentScroll > pheight) {
          header.addClass('header-sticky');
          if (header.hasClass('header-visible')) {
            header.removeClass('header-visible');
          }
        }
      } else {
        if (currentScroll < lastScroll) {
          header.addClass('header-sticky').addClass('header-visible');

          if (currentScroll <= pheight) {
            header.removeClass('header-sticky header-visible');
          }
        }
      }
      lastScroll = currentScroll;
    });
    jQuery(window).scroll();
  }

  function Tabs() {
    $('.tab').tabset({
      tabLinks: 'a',
      activeClass: 'tab-active',
      defaultTab: true,
    });
  }

  function OpenClose() {
    $('[data-more]').next().hide();
    $('[data-more].active').next().show();

    $('[data-more]').click(function (e) {
      e.preventDefault();
      $(this).hasClass('active')
        ? $(this).removeClass('active').next().slideUp(200)
        : $(this).addClass('active').next().slideToggle(200);

      if ($(this).closest('[data-accordion]').length) {
        $(this).parent().siblings().find('[data-more]').removeClass('active');
        $(this).parent().siblings().find('[data-more]').next().slideUp(200);
      }
    });

    $('[data-outside]')
      .next()
      .find('a:not(.hasdrop-a):not([data-more])')
      .click(function () {
        $('[data-outside]').removeClass('active').next('').slideUp(200);
      });
    $('[data-outside]').click(function (e) {
      $('[data-outside]').not(this).removeClass('active').next().slideUp(200);
    });

    $('html').on('click touchstart pointerdown MSPointerDown', function (e) {
      var target = $(e.target);

      if (!target.closest('[data-outside]').length && !target.closest('[data-outside] + *').length) {
        setTimeout(function () {
          $('[data-outside]').removeClass('active').next().slideUp(200);
        }, 200);
      }

      if (!target.closest('[data-outside-1]').length && !target.closest('[data-outside-1] + *').length) {
        setTimeout(function () {
          $('[data-outside-1]').removeClass('active').next().slideUp(200);
        }, 200);
      }
    });
  }

  function LineAnimation() {
    var leftPos, newWidth, $magicLine;

    $('[data-line]').append("<li class='magic-line'></li>");

    $magicLine = $('.magic-line');
    $magicLine.width($('[data-line] li.active').width());

    $('[data-line] li a').click(function () {
      var $this = $(this);
      $this.parent().addClass('active').siblings().removeClass('active');

      $magicLine = $this.parent().siblings('.magic-line');

      leftPos = $this.position().left;
      newWidth = $this.parent().width();
      $magicLine.css({
        left: leftPos,
        width: newWidth,
      });
    });
  }

  function InlineSVG() {
    $('.inline-svg').each(function () {
      var img = $(this);
      if (img.length > 0) {
        $.get(img[0].src, function (svgDoc) {
          var importedSVGRootElement = document.importNode(svgDoc.documentElement, true);
          if (img.hasClass('no-fill')) {
            img.parent().html(importedSVGRootElement);
          } else {
            img.parent().html(importedSVGRootElement).find('svg').addClass('fill-current');
          }
        });
      }
    });
  }

  function NavToggle() {
    var dclass = jQuery('[data-click="menu-a"]').next().attr('class');
    jQuery('[data-click="menu-a"] a').click(function (e) {
      e.preventDefault();
      jQuery('[data-click="menu-a"] a').removeClass('menu-active');
      jQuery('[data-click="menu-a"]').next().attr('class', dclass);
      $(this).hasClass('menu-active') ? $(this).removeClass('menu-active') : $(this).addClass('menu-active');
      jQuery(this).parents('[data-click="menu-a"]').next().addClass(jQuery(this).text().toLowerCase());
    });
  }

  function NavItemHover() {
    jQuery('.navmain-drop-link')
      .on('mouseover', function () {
        jQuery(this).parent().parent().parent().siblings().addClass('hovered');
        jQuery(this).parent().siblings().addClass('hovered');
      })
      .on('mouseout', function () {
        jQuery(this).parent().parent().parent().siblings().removeClass('hovered');
        jQuery(this).parent().siblings().removeClass('hovered');
      });
  }

  $(document).ready(function ($) {
    FixedHeader();
    MobileNav();
    OpenClose();
    Tabs();
    NavItemHover();
    NavToggle();
    LineAnimation();
    InlineSVG();
  });
})(jQuery);
